<template>
    <div class="add-info">
        <mt-field label="消息内容" :type="message_Type" rows="4" :placeholder="placetext" v-model="currentMessage"></mt-field>
        <mt-radio
            title="消息类型"
            v-model="message_type"
            :options="options"
            @change="messageTypeChange">
        </mt-radio>
        <mt-button class="submit-btn" size="large" type="primary" @click.native="addAgentMessage()">下发消息</mt-button>
    </div>
</template>

<script>
export default {
    data () {
        return {
            options: [
                {
                    label: '文本',
                    value: '1'
                },
                {
                    label: '链接',
                    value: '2'
                }
            ],
            message_type: '1',
            message_Type: 'textarea',
            placetext: '请输入文本',
            currentMessage: ''
        }
    },
    methods: {
        messageTypeChange() {
            console.log(this.message_type)
            if(this.message_type == 1) {
                this.message_Type = 'textarea'
                this.placetext = '请输入文本'
            }else{
                this.message_Type = 'url'
                this.placetext = '请输入链接'
            }
        },
        addAgentMessage() {
            let _this = this,
                mes_obj = {
                    ContentType: _this.message_type,
                    Message: _this.currentMessage.trim()
                };
            if(mes_obj.ContentType != "") {
                if(_this.message_type == 2) {
                    let regexStr = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
                    var re = new RegExp(regexStr);
                    if (!re.test(mes_obj.Message)) {
                        _this.abp.api.reqSuccess(_this,'请输入正确的链接地址！')
                        return false;
                    }
                }
                _this.$indicator.open('加载中...');
                _this.abp.api.AgentNotice(mes_obj)
                    .then((res)=> {
                        console.log(res);
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                _this.currentMessage = '';
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=> {
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
            }else{
                _this.abp.api.reqSuccess(_this,'请输入有效内容！')
            }
        }
    }
}
</script>
<style>
.add-info .submit-btn {
    width: 300px;
    margin: auto;
    margin-top: 50px;
}
/* .award-name{-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%; //超出部分显示省略号} */
</style>


